import { Link } from 'react-router-dom';
import { ArrowRight, LockKeyhole, MapPinned, ShieldCheck } from 'lucide-react';
import { Reveal, TiltCard } from '../components/motion';
import { OperatingModelSection } from './sections';

const PRINCIPLES = [
  { icon: ShieldCheck, title: 'Nothing invented', copy: 'AI drafts are built from the details you provide. Reviews, ratings, and metrics are never fabricated on your behalf.' },
  { icon: LockKeyhole, title: 'Access enforced server-side', copy: 'Plan limits and permissions are checked by the API, not hidden in the interface, so entitlements are real.' },
  { icon: MapPinned, title: 'Built for local operators', copy: 'Every module targets how local businesses actually win work: visibility, speed of response, and follow-through.' },
];

export default function About() {
  return (
    <>
      <section className="page-hero">
        <Reveal className="page-hero-inner">
          <div className="section-tag">ABOUT DATA TALLIED</div>
          <h1>One system instead of nine disconnected tools.</h1>
          <p>
            Most local businesses run growth across a website builder, a forms tool, a spreadsheet, an inbox, a review app,
            and a rank checker that never talk to each other. Data Tallied puts capture, response, conversion, and reporting
            on one customer record.
          </p>
          <div className="page-hero-actions">
            <Link to="/products" className="btn-primary">See the platform <ArrowRight size={16} /></Link>
            <a href="mailto:host@loadedloaded.com" className="btn-ghost">Talk to the team</a>
          </div>
        </Reveal>
      </section>

      <section className="about-principles">
        <Reveal className="section-header">
          <div className="section-tag">HOW WE BUILD</div>
          <h2 className="section-title">Principles behind the product.</h2>
        </Reveal>
        <div className="about-grid">
          {PRINCIPLES.map(item => {
            const Icon = item.icon;
            return (
              <TiltCard as="article" className="about-card" intensity={4} lift={4} key={item.title}>
                <span className="about-card-icon"><Icon size={19} /></span>
                <h3>{item.title}</h3>
                <p>{item.copy}</p>
              </TiltCard>
            );
          })}
        </div>
      </section>

      <OperatingModelSection />

      <section className="home-cta">
        <div className="home-cta-inner">
          <div>
            <div className="section-tag">BASED IN FLORIDA</div>
            <h2>Questions before you start?</h2>
            <p>Send account, setup, integration, or plan questions directly to the team. We answer from a real inbox.</p>
          </div>
          <div className="home-cta-actions">
            <a href="mailto:host@loadedloaded.com" className="btn-primary">Contact support <ArrowRight size={16} /></a>
            <Link to="/free-tools" className="btn-ghost">Try the free scan</Link>
          </div>
        </div>
      </section>
    </>
  );
}
